import request from '@/utils/request'

/** 查找区域弹出框，分页查询区域信息 */
export function getRegionPopUpList(pageInfo, regionName) {
    return request({
        url: `/system/region/popup?pageSize=${pageInfo.pageSize}&pageNum=${pageInfo.pageNum}&regionName=${regionName}`,
        method: 'get'
    });
}

/** 查找校区弹出框，分页查询校区信息 */
export function getSchoolPopUpList(pageInfo, regionId, schoolName) {
    return request({
        url: `/system/xq/popup?pageSize=${pageInfo.pageSize}&pageNum=${pageInfo.pageNum}&regionId=${regionId}&schoolName=${schoolName}`,
        method: 'get'
    });
}

/** 查找用户弹出框，分页查询用户信息 */
export function getUserPopUpList(params = {}) {
    return request({
        url: `/system/user/popup`,
        method: 'get',
        params
    });
}

/** 查找市场渠道弹出框，分页查询渠道信息 */
export function getChannelPopUpList(pageInfo, parentId, channelName) {
    return request({
        url: `/system/marketChannel/popup?pageSize=${pageInfo.pageSize}&pageNum=${pageInfo.pageNum}&parentId=${parentId}&channelName=${channelName}`,
        method: 'get'
    });
}

/** 合作商名称查找弹出框, 分页查询合作商信息 */
export function getPartnerPopUpList(pageInfo, partnerName) {
    return request({
      url: `/system/intention/partner/popup?pageSize=${pageInfo.pageSize}&pageNum=${pageInfo.pageNum}&partnerName=${partnerName}`,
      method: 'get'
    });
  }